import React from 'react';
import {Link} from 'react-router-dom';

import Unauthenticated from 'Components/Layouts/Unauthenticated';

import Start from "Pages/PacManGame/Start";
import Game from "Pages/PacManGame/Game";
import HowToPlay from "Pages/PacManGame/HowToPlay";
import Leaderboard from "Pages/PacManGame/Leaderboard";
import End from "Pages/PacManGame/End";

import {asset} from 'Services/BaseHelpers';

export default class PacManGame extends React.Component {
    /**
     * @var state
     */
    state = {
        stage: 'start',
        protectingImage: 'mobile',
        score: 0,
        gameCompleted: false,
        rotateMessage: false
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        // Set up the rotateMessage.
        this.setRotateMessage();

        // Set the rotateMessage to update if the window size updates.
        window.addEventListener('resize', this.setRotateMessage);
    }

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        // Remove the resize window listener
        window.removeEventListener('resize', this.setRotateMessage);
    }

    /**
     * @method setRotateMessage
     */
    setRotateMessage = () => {
        // If mobile screen and in vertical mode then display a message to the user
        // to rotate their device.
        if (window.innerWidth < 780 && window.innerWidth < window.innerHeight) {
            this.setState({
                rotateMessage: true
            });
        } else {
            this.setState({
                rotateMessage: false
            });
        }
    }

    /**
     * @method render
     * @return {*}
     */
    render () {
        const {rotateMessage} = this.state;

        return (
            <Unauthenticated
                container={false}
                header={false}
            >
                <div className="absolute top-5 left-5 lg:top-10 lg:left-10 z-20">
                    <Link to="/dashboard">
                        <img
                            src={asset('/images/pacman/ee_logo.png')} 
                            className="w-8 lg:w-16 z-20"
                        />
                    </Link>
                </div>

                {rotateMessage && this.renderRotationMessage()}

                {!rotateMessage && 
                    <div className="relative z-0">
                        <img
                            src={asset('/images/pacman/arcade-bg.png')}
                            className="h-screen mx-auto top-0 bottom-0 left-0 right-0 absolute z-0"
                            alt="PacMan Background"
                        />

                        <div className="relative w-1/2 h-[80vh] pt-6 md:pt-12 lg:pt-20 xl:pt-24 2xl:pt-28 mx-auto z-10 relative">
                            {this.renderStage()}
                        </div>
                    </div>
                }
            </Unauthenticated>
        );
    }

    /**
     * @method renderRotationMessage
     * @return {*}
     */
    renderRotationMessage() {
        return (
            <div className="absolute top-0 left-0 right-0 w-screen h-screen z-50 bg-app-turquoise flex items-center justify-center flex-col text-center">
                <div className="absolute top-5 left-5 lg:top-10 lg:left-10">
                    <img
                        src={asset('/images/pacman/ee_logo.png')}
                        className="w-8 lg:w-16"
                    />
                </div>

                <p className="uppercase text-4xl nobblee-bold text-app-yellow">
                    BEFORE WE BEGIN
                </p>

                <p className="text-xl rubrik-regular text-app-yellow">
                    Rotate your handset to landscape
                </p>

                <img
                    src={asset('/images/pacman/rotate-device.png')}
                    className="mt-10 h-16"
                />
            </div>
        );
    }

    /**
     * @method renderStage
     * @return {*}
     */
    renderStage() {
        const {stage, protectingImage, score, gameCompleted} = this.state;

        switch(stage) {
            case 'start':
                return <Start 
                    setParentState={(state) => this.setState(state)}
                />;
            case 'leaderboard':
                return <Leaderboard 
                    setParentState={(state) => this.setState(state)}
                />;
            case 'how-to-play':
                return <HowToPlay 
                    setParentState={(state) => this.setState(state)}
                    protectingImage={protectingImage}
                />;
            case 'game':
                return <Game 
                    setParentState={(state) => this.setState(state)}
                    protectingImage={protectingImage}
                />;
            case 'end':
                return <End 
                    setParentState={(state) => this.setState(state)}
                    score={score}
                    gameCompleted={gameCompleted}
                />;
        }
    }
}
